import React, { PropTypes, Component } from 'react'
import { RadioGroup, Radio } from 'react-radio-group'
import classes from './RadioButtonGroup.scss'

class RadioButtonGroup extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    selectedValue: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,

    disabled: PropTypes.bool,
    groupClassName: PropTypes.string,
    radioClassName: PropTypes.string,
    titleClassName: PropTypes.string
  };

  static defaultProps = {
    groupClassName: '',
    radioClassName: '',
    titleClassName: classes.radioTitle,
    disabled: false
  };

  constructor (props) {
    super(props)
    this.state = { selectedValue: props.selectedValue }
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.selectedValue !== nextProps.selectedValue) {
      this.setState({ selectedValue: nextProps.selectedValue })
    }
  }

  render () {
    const { name, disabled, onChange, options, groupClassName, radioClassName, titleClassName } = this.props
    return (
      <RadioGroup className={groupClassName} name={name}
        selectedValue={this.state.selectedValue}
        onChange={onChange}>
        {options.map(({ value, title, dom }) =>
          <span key={value} className={`${classes.radio} ${radioClassName} ${this.state.selectedValue === value && classes.radioActive}`}>
            <Radio value={value} disabled={disabled} />
            {title && <span className={titleClassName}>{title}</span>}
            {dom}
          </span>
        )}
      </RadioGroup>
    )
  }
}

export default RadioButtonGroup



// WEBPACK FOOTER //
// ./src/components/RadioButtonGroup.js